var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMatP(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".subject-mat-p-1{fill:#464af0;}.subject-mat-p-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Matematyka") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4079",
    "data-name": "Group 4079"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_77",
    "data-name": "Group 77"
  }, /*#__PURE__*/React.createElement("path", {
    className: "subject-mat-p-2",
    d: "M37.6,16.08s0-.09,0-.13,0,0,0,0l-.06-.15h0a.45.45,0,0,0-.1-.14l0,0-.1-.08a0,0,0,0,1,0,0h0l0,0L25.33,9.52a.72.72,0,0,0-.67,0L12.81,15.44l0,0h0l0,0-.1.08,0,0a.76.76,0,0,0-.11.14h0l-.06.15s0,0,0,0a.59.59,0,0,0,0,.13V33.89a.76.76,0,0,0,.41.67l11.85,5.92h0l.11,0,.05,0h.32l0,0,.12,0h0l11.86-5.92a.76.76,0,0,0,.41-.67V16.08ZM25,11l10.18,5.09L25,21.2,14.82,16.11Zm-11.1,6.3L24.25,22.5V38.6L13.9,33.43ZM36.1,33.43,25.75,38.6V22.5L36.1,17.32Z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatP);
export default __webpack_public_path__ + "static/media/mat-p.28e9f83c34a09be6bfaf8a535a3776f8.svg";
export { ForwardRef as ReactComponent };